module.exports = __webpack_public_path__ + "static/voucher-2a84ed64264aadb686ec614e02a8960f.png";